/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import { provincesAutoCompleteSuccessful, provincesAutoCompleteError, provincesAutoCompleteRequest } from 'action-creators/provincesAutocomplete';
import { ProvinceAutoCompleteRequestResponse } from 'models/provinceAutoComplete';
import { getCurrentLanguage } from 'utils/generic';
import { getLanguageWithoutRegion } from 'utils/i18n';

import { axiosConfig, netaticaProvinces } from '../api';

export const searchProvincesAutocomplete =
  (text: string, countryCode: string): MyThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    try {
      dispatch(provincesAutoCompleteRequest());
      const { country } = getState().i18n;
      const currentLanguage = country ? getLanguageWithoutRegion(getCurrentLanguage()) : 'ES';

      const { data } = await netaticaProvinces.get<ProvinceAutoCompleteRequestResponse>('', {
        params: {
          countryCode: countryCode,
          text: text.sanitizeExceptAccents(),
          language: currentLanguage.toUpperCase()
        },
        ...axiosConfig,
      });

      dispatch(provincesAutoCompleteSuccessful(data.data));
    } catch (ex) {
      dispatch(provincesAutoCompleteError(ex));
    }
  };
